import * as PIXI from "pixi.js";
import { BasePopupScene } from "./BasePopupScene.js";

export class NoFundsPopupScene extends BasePopupScene {
    create() {
        super.create();
        const resources = this.services.get("resources");

        this._panel.position.set(960, 540);

        const bgTex = resources.get("no_funds/bg");
        if (bgTex) {
            const bg = new PIXI.Sprite(bgTex);
            bg.anchor.set(0.5);
            this._panel.addChild(bg);
        }

        const title = new PIXI.Text({
            text: "INSUFFICIENT FUNDS",
            style: { fontFamily: "halant_bold", fontSize: 36, fill: 0xF9CD82 },
        });
        title.anchor.set(0.5);
        title.position.set(0, -30);
        this._panel.addChild(title);

        this._addCloseButton(250, -180);
    }
}
